/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { yearToCropYearFull, yearToCropYearShort, OLAPTransformerResult, useDictionaryItem, useParameter } from "../../../shared";
import Highcharts, { SeriesOptionsType, SeriesPackedbubbleOptions } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe, addYAxisPipe } from "../../../../charts/pipes";
import { groupBy, orderBy, sumBy } from "lodash";
import { shortCountries } from "../utils/shortCountries";
import { dictionaryService } from "../../../dataFlow";
import { SingleValueParameter } from "@sa/rep-core";
import { DictionaryItem } from "@sa/rep-mdm";

const CATEGORIES_AXIS = "calendar.default";
const SERIES_AXIS = "countries.default";
const SERIES_AXIS2 = "commodities.default";

export function useChart1(
  data1: OLAPTransformerResult | null,
  data2: OLAPTransformerResult | null,
): Highcharts.Options | undefined {
  const [state, setState] = useState<Highcharts.Options>();
  const categories = useMemo(
    () => data1 && data1.columns.map((x) => x.headers.find((h) => h.id === `${CATEGORIES_AXIS}.name`)?.name || ""),
    [data1],
  );
  const categories2 = useMemo(
    () => data2 && data2.columns.map((x) => x.headers.find((h) => h.id === `${CATEGORIES_AXIS}.name`)?.name || ""),
    [data2],
  );

  const [cropCalendar] = useParameter("@crop_calendar");
  const [,cropCalendarName] = useDictionaryItem(dictionaryService, "calendar-gi", cropCalendar as number);

  const options = useChartOptions({}, [
    chartPipe("column"),
    legendPipe("top", {
      labelFormatter: function() {
        const { name } = this;
        switch (name) {
          case "Production":
            return name + " (million mt)";
          case "Area Harvested":
            return name + " (million ha)";
          case "Yield":
            return name + " (mt/ha)";
          default:
            return name;
        }
      },
    }),
    addXAxisPipe(categories),
    addXAxisPipe(categories2, {
      opposite: true,
      visible: false,
      labels: {
        formatter: function() {
          return ``;
      },
      }
    }),
    addYAxisPipe({
      labels: {
        formatter: function() {
          var label = this.axis.defaultLabelFormatter.call(this);
          if (/^[0-9]{4}$/.test(label)) {
            return Highcharts.numberFormat(this.value, 0);
          }
          return label;
        },
      },
      plotLines: [{
        width: 2,
        color: "grey",
        value: 100,
        dashStyle: "LongDash",
        zIndex: 5,
      }],
    }),
    addYAxisPipe({
      opposite: true,
      labels: {
        formatter: function() {
            return `${Highcharts.numberFormat(this.value, 0)}%`;
        },
      },
    }),
    tooltipPipe((serie) => {
      switch (serie) {
        case "Production":
          return "million mt";
        case "Area Harvested":
          return "million ha";
        case "Yield":
          return "mt/ha";
        default:
          return "";
      }
    }),
  ]);

  useEffect(() => {
    if (data1 && data2) {
      const dataRow1 = data1.rows[0];
      const columnSeries1 = [{
          type: "column",
          yAxis: 1,

          color: '#65AC1E',
          showInLegend: true,
          dataLabels: {
            enabled: false,
          },
          name: "Stock To Use-Ratio* In %",
          id: `Stock To Use-Ratio* In %`,
          data: dataRow1.points.map((p) => p.value),
        }];

      const dataRow2 = data2.rows[0];
      const columnSeries2: SeriesOptionsType = {
        type: "spline",
        yAxis: 0,
        xAxis: 1,
        color: "#005897",
        dashStyle: "Solid",
        lineWidth: 3,
        zIndex: 1,
        marker: {
          symbol: "diamond",
        },
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        states: {
          hover: {
            lineWidth: 0,
            lineWidthPlus: 0,
          },
        },
        name: `Indexes (Base 100 in ${cropCalendarName})`,
        id: dataRow2.attributes[`calendar.default.name`],
        data: dataRow2.points.map((p) => p.value || 0),
      };

      const result: Highcharts.Options = {
        ...options,
        series: columnSeries1.concat([columnSeries2 as any]) as any,
      };

      setState(result);
    }
  }, [data1, data2]);
  return state;
}
